module.exports = __webpack_public_path__ + "static/media/IMG_5840-min.4b938c47.jpg";